<template>
  <div class="iv-container">

    <!-- Wallboards -->

    <!-- New -->
    <!-- Title -->
    <div class="row mar-b30">
      <div class="col-xs-12 col-sm-6">
        <h5>Your Wallboards</h5>
      </div>
      <div class="col-xs-12 col-sm-6 end-xs">
        <button type="button" class="iv-btn" v-on:click="create">Create Wallboard</button>
      </div>
    </div>

    <!-- Spinner -->
    <div v-if="!loaded">
      <div class="spinner"></div>
    </div>

    <!-- Wallboards -->
    <div v-if="loaded" class="row">
      <div v-if="!wallboards.length" class="col-xs-12 center-xs mar-t30">
        <span>
          You don't have any
          <strong>Wallboards</strong> yet - click
          <a v-on:click="create">here</a> to create your first one
        </span>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 mar-b30" v-for="wallboard in wallboards" :key="wallboard.id">
        <Wallboard-Preview :wallboard="wallboard" :onSelect="() => select(wallboard.id)" :onDelete="(ev) => deleteWallboard(ev, wallboard)"/>
      </div>
    </div>

    <!-- Old -->
    <!-- <div class="row">
      <div class="col-xs-12 col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2">
        <div class="flexBetween mar-b30">
          <span class="textXLarge">Wallboards</span>
          <button type="button" class="btn btn-md" v-on:click="create">Create Wallboard</button>
        </div>
        <div v-if="!loaded">
          <div class="spinner"></div>
        </div>
        <div v-if="loaded" class="row">
          <div v-if="!wallboards.length" class="col-xs-12 center-xs mar-t30">
            <span>
              You don't have any
              <strong>Wallboards</strong> yet - click
              <a v-on:click="create">here</a> to create your first one
            </span>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mar-b20" v-for="wallboard in wallboards" :key="wallboard.id">
            <Wallboard-Preview :wallboard="wallboard" :onSelect="() => select(wallboard.id)" :onDelete="(ev) => deleteWallboard(ev, wallboard)"/>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Drawer -->
    <!-- New -->
    <Drawer :isOpen="creating" :onClose="() => {}">
      <div class="row mar-b30">
        <div class="col-xs-12">
          <p>Let's give your wallboard a name.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label for>Wallboard Name</label>
            <input v-model="newWallboard.name" placeholder="Enter wallboard name here…">
          </div>
        </div>
      </div>
      <div class="row mar-b30">
        <div class="col-xs-12">
          <p>Do you want to make your wallboard public?</p>
        </div>
      </div>
      <div class="row mar-b15">
        <div class="col-xs-12">
          <div class="form-group">
            <label for>Make Public</label>
            <label class="switch">
              <input type="checkbox" :checked="newWallboard.public" v-on:change="ev => newWallboard.public = ev.target.checked">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="row mar-b15">
        <div class="col-xs-12">
          <div class="h-bar"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 end-xs">
          <ul class="btn-list">
            <li><button class="iv-btn grey" v-on:click="() => creating = false">Cancel</button></li>
            <li><button class="iv-btn" v-on:click="confirmCreate">Create</button></li>
          </ul>
        </div>
      </div>
    </Drawer>

    <!-- Drawer - Warning -->
    <Drawer :isOpen="deleting" :onClose="() => {}">
      <div class="row mar-b30">
        <div class="col-xs-12">
          <p>Are you sure that you want to delete the wallboard <span class="p-bold primary"> {{deleting ? deleting.name : ''}}? </span></p>
        </div>
      </div>
      <div class="row mar-b15">
        <div class="col-xs-12">
          <div class="h-bar"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 end-xs">
          <ul class="btn-list">
            <li><button class="iv-btn grey" v-on:click="() => deleting = undefined">Cancel</button></li>
            <li><button class="iv-btn warning" v-on:click="confirmDelete">Delete</button></li>
          </ul>
        </div>
      </div>
    </Drawer>

    <!-- Old -->
    <!-- <Drawer :isOpen="creating" :onClose="() => {}">
      <div class="row">
        <div class="col-xs-12 mar-b30 center-xs">
          <h3>Please give this wallboard a name</h3>
        </div>
        <div class="col-xs-12">
          <div class="form-group">
            <label for>Name</label>
            <input v-model="newWallboard.name" placeholder="wallboard name">
          </div>
        </div>
        <div class="col-xs-12">
          <div class="form-group">
            <label for>Public</label>
            <label class="switch">
              <input type="checkbox" :checked="newWallboard.public" v-on:change="ev => newWallboard.public = ev.target.checked">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="col-xs-6">
          <button type="button" class="btn btn-md full-width primary" v-on:click="confirmCreate">Create</button>
        </div>
        <div class="col-xs-6">
          <button type="button" class="btn btn-md full-width grey" v-on:click="() => creating = false">Cancel</button>
        </div>
      </div>
    </Drawer>

    <Drawer :isOpen="deleting" :onClose="() => {}">
      <div class="row">
        <div class="col-xs-12 mar-b30">
          <h3>Are you sure you want to delete {{deleting ? deleting.name : ''}}?</h3>
        </div>
        <div class="col-xs-6">
          <button type="button" class="btn btn-md full-width primary" v-on:click="confirmDelete">Yes</button>
        </div>
        <div class="col-xs-6">
          <button type="button" class="btn btn-md full-width secondary" v-on:click="() => deleting = undefined">No</button>
        </div>
      </div>
    </Drawer> -->

  </div>
</template>

<script>
import axios from "../utils/axios";
import WallboardPreview from "../components/wallboard/WallboardPreview";
export default {
  name: "home",
  components: { WallboardPreview },
  created: function() {
    this.getWallboards();
  },
  data() {
    return {
      loaded: false,
      deleting: undefined,
      newWallboard: {
        name: "",
        public: false
      },
      creating: false,
      total: 0,
      wallboards: []
    };
  },
  methods: {
    getWallboards() {
      axios.get("wallboards").then(response => {
        this.loaded = true;
        this.total = response.data[1];
        this.wallboards = response.data[0];
      });
    },
    deleteWallboard(ev, wallboard) {
      ev.stopPropagation();
      this.deleting = wallboard;
      return false;
    },
    confirmDelete() {
      axios.delete("wallboards/" + this.deleting.id).then(() => {
        this.deleting = undefined;
        this.getWallboards();
      });
    },
    select(id) {
      this.$router.push("/wallboards/" + id);
    },
    create() {
      this.creating = true;
      this.newWallboard = { name: "", public: false };
    },
    confirmCreate() {
      axios.post("wallboards", this.newWallboard).then(response => {
        this.creating = false;
        this.$router.push("/wallboards/" + response.data.id);
      });
    }
  }
};
</script>
